import { StructuredContentRenderer } from '../renderer';
import type { NodeProps, StructuredContent } from '../types';

export type WPInlineBlockProps = NodeProps<{
  id: number | string;
  content?: StructuredContent;
}>;

/**
 * Inline WP block (supergraph WPInlineBlock hydration fills `content`). Renders nested so the
 * block's `Type` stays a `<span>` inside the surrounding paragraph.
 * Source: NerdWallet/structured-content shared-core/src/components/wp-inline-block.
 */
export function WPInlineBlock({ props }: WPInlineBlockProps) {
  const { content } = props;
  if (!content || typeof content === 'string' || content.type !== 'Document') return null;
  if (content.props.inline !== true) return null;

  return (
    <span>
      <StructuredContentRenderer doc={content.props.children} nested />
    </span>
  );
}
